<template>
  <el-button
    @click="$emit('click')"
    data-id="generateFieldsWithAi"
    :size="size"
    type="mini"
    class="is-plain el-button--ai shimmer"
    :loading="loading"
    :style="buttonStyle"
  >
    <div class="d-flex flex-row gap-2 align-items-center justify-content-center" v-if="!loading">
      <span class="material-icons">auto_awesome</span><span>{{ $i18n.t(title) }}</span>
    </div>
  </el-button>
</template>

<script>
export default {
  name: 'AiButton',
  props: {
    size: {
      type: String,
      default: 'medium',
    },
    title: {
      type: String,
      default: 'generate',
    },
    buttonStyle: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
